import React, { FC } from 'react';
import clsx from 'clsx';
import { MiniCartPopUpProps } from './types';
import Link from '@base/components/src/Link';
import styles from './MiniCartPopUp.module.css';
import config from 'config-base';
import currencyFormatting from '@package/utils/src/currencyFormatting';
import { ShoppingCartStepType } from '@package/core/src/shoppingCart';
import useLabelVatiants from '@package/hooks/src/useLabelVatiants';
import List from '../CartPopUpList';
import Button from '../../../Button';

const MiniCartPopup: FC<MiniCartPopUpProps> = ({
  cartItems,
  showTopShade,
  showBottomShade,
  hoverCartScroll,
  mobile,
  height,
  miniCartData,
  deleteProduct,
  getList,
  redirectStart,
}) => {
  const { v } = useLabelVatiants();

  const handleKeepShopping = () => {
    config.brandCode === '2'
      ? (window.location.href = `${config.mainPyramydairUrl}/cart`)
      : (window.location.href = ShoppingCartStepType.ShoppingCart);
  };

  return (
    <div className={clsx(styles.withItems, { [styles.withItemsAGD]: config.brandCode === '2' })}>
      <div className={styles.header}>
        {config.brandCode === '0' ? (
          <>
            <div>
              {cartItems} {cartItems == 1 ? 'Item' : 'Items'}
            </div>
            <Link href={config.shoppingCart}>View Cart</Link>
            <div
              id="top-shade"
              className={styles.topShade}
              style={{ display: `${showTopShade ? 'block' : 'none'}` }}
            ></div>
          </>
        ) : (
          <>
            <div className={styles.headerTextAGD}>Shopping Cart</div>
            <div className={styles.headerCheckoutAGD} onClick={handleKeepShopping}>
              checkout
            </div>
          </>
        )}
      </div>
      <div
        id="product-list"
        className={styles.list}
        style={!mobile ? { maxHeight: `${height}px` } : {}}
        onScroll={hoverCartScroll}
      >
        <List
          items={miniCartData}
          orderId={miniCartData.orderId}
          deleteItem={async (deleteProductData) => {
            await deleteProduct(deleteProductData);
            await getList();
          }}
        />
      </div>

      <div className={styles.footer}>
        <div className={clsx(styles.footerContainer, { [styles.footerContainerAGD]: config.brandCode === '2' })}>
          <div
            id="bottom-shade"
            className={styles.bottomShade}
            style={{ display: `${showBottomShade ? 'block' : 'none'}` }}
          ></div>
          <div className={clsx(styles.subTotal, { [styles.subTotalAGD]: config.brandCode === '2' })}>
            <span>Subtotal:</span>
            <span>{currencyFormatting(miniCartData.subTotal)}</span>
          </div>
          <div
            className={clsx(styles.checkoutPopUpContainer, {
              [styles.checkoutPopUpContainerAGD]: config.brandCode === '2',
            })}
          >
            {config.brandCode === '2' && !mobile && (
              <div className={styles.keepShopping} onClick={handleKeepShopping}>
                KEEP SHOPPING
              </div>
            )}
            <Button
              id="cart-proceed-btn"
              fullWidth
              loading={redirectStart}
              size={'medium'}
              classes={clsx({
                [styles.proceedCheckoutButton]: config.brandCode === '0',
                [styles.proceedCheckoutButtonAGD]: config.brandCode === '2',
              })}
              label={<p className={styles.proceedCheckoutButtonText}>{v('miniCartPopUpButton')}</p>}
              onClick={handleKeepShopping}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniCartPopup;
